import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_2 = {
  key: 2,
  class: "empty-state"
}

import { IonButton, IonButtons, IonCheckbox, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonSearchbar, IonSpinner, IonTitle, IonToolbar, modalController } from "@ionic/vue";
import { closeOutline, saveOutline } from "ionicons/icons";
import { translate } from '@hotwax/dxp-components';
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { DateTime } from "luxon";
import { ChannelService } from "@/services/ChannelService";
import { UtilService } from "@/services/UtilService";
import { hasError, showToast } from "@/utils";
import logger from "@/logger";
import emitter from "@/event-bus";


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkFacilitiesToGroupModal',
  props: ["group", "selectedFacilities"],
  setup(__props) {

const store = useStore();
const queryString = ref('');
const selectedFacilityValues = ref([]) as any;
const isLoading = ref(false);

const props = __props;
const facilities = ref([]) as any;

onMounted(() => {
  fetchFacilities()
  selectedFacilityValues.value = JSON.parse(JSON.stringify(props.selectedFacilities));
})

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

async function fetchFacilities () {
  isLoading.value = true;
  facilities.value = []

  try {
    let params = {
      productStoreId: store.state.user.currentEComStore.productStoreId,
      pageSize: 200,
      parentFacilityTypeId: 'VIRTUAL_FACILITY',
      parentFacilityTypeId_not: 'Y',
      facilityTypeId: 'VIRTUAL_FACILITY',
      facilityTypeId_not: 'Y',
    } as any;

    if(queryString.value) {
      params = {
        ...params,
        facilityName: queryString.value,
        facilityName_op: "contains"
      }
    }

    const resp = await UtilService.fetchFacilities(params);

    if(!hasError(resp)) {
      facilities.value = resp.data;
    } else {
      throw resp.data
    }
  } catch (err: any) {
    logger.error(err)
  }
  isLoading.value = false;
}

function isFacilitySelected(facilityId: string) {
  return selectedFacilityValues.value.some((facility: any) => facility.facilityId === facilityId)
}

function updateSelectedFacilities(id: string) {
  if(isFacilitySelected(id)) {
    selectedFacilityValues.value = selectedFacilityValues.value.filter((facility: any) => facility.facilityId !== id)
  } else {
    selectedFacilityValues.value.push(facilities.value.find((facility: any) => facility.facilityId == id))
  }
}

function areFacilitiesUpdated() {
  if(props.selectedFacilities.length !== selectedFacilityValues.value.length) return true;

  return selectedFacilityValues.value.some((selectedFacility: any) => !props.selectedFacilities.find((facility: any) => facility.facilityId === selectedFacility.facilityId))
}

async function saveFacilities() {
  emitter.emit("presentLoader");
  const facilitiesToAdd = selectedFacilityValues.value.filter((selectedFacility: any) => !props.selectedFacilities.some((facility: any) => facility.facilityId === selectedFacility.facilityId))
  const facilitiesToRemove = props.selectedFacilities.filter((facility: any) => !selectedFacilityValues.value.some((selectedFacility: any) => facility.facilityId === selectedFacility.facilityId))

  const removeResponses = await Promise.allSettled(facilitiesToRemove
    .map(async (facility: any) => await ChannelService.updateFacilityAssociationWithGroup({
      facilityId: facility.facilityId,
      facilityGroupId: props.group.facilityGroupId,
      fromDate: facility.fromDate,
      thruDate: DateTime.now().toMillis()
    }))
  )

  const addResponses = await Promise.allSettled(facilitiesToAdd
    .map(async (facility: any) => await ChannelService.updateFacilityAssociationWithGroup({
      facilityId: facility.facilityId,
      facilityGroupId: props.group.facilityGroupId,
      fromDate: DateTime.now().toMillis()
    }))
  )

  const hasFailedResponse = [...removeResponses, ...addResponses].some((response: any) => response.status === 'rejected')
  if(hasFailedResponse) {
    showToast(translate("Failed to associate some facilites to group."))
  } else {
    showToast(translate("Facilities associated to group successfully."))
  }
  await store.dispatch("channel/fetchGroupFacilities", props.group.facilityGroupId);
  modalController.dismiss()  
  emitter.emit("dismissLoader");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Link facilities")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSearchbar), {
          modelValue: queryString.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryString).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchFacilities()), ["enter"]))
        }, null, 8, ["modelValue"]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonItem), { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSpinner), {
                    name: "crescent",
                    slot: "start"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)("Fetching facilities")), 1)
                ]),
                _: 1
              })
            ]))
          : (facilities.value?.length)
            ? (_openBlock(), _createBlock(_unref(IonList), { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilities.value, (facility) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), {
                      lines: "none",
                      key: facility.facilityId,
                      onClick: ($event: any) => (updateSelectedFacilities(facility.facilityId))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), {
                          checked: isFacilitySelected(facility.facilityId)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(facility.facilityName) + " ", 1),
                                _createElementVNode("p", null, _toDisplayString(facility.facilityId), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["checked"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("p", null, _toDisplayString(_unref(translate)("No facility found.")), 1)
              ])),
        _createVNode(_unref(IonFab), {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), {
              disabled: !areFacilitiesUpdated(),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (saveFacilities()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})